import { OccupancyPricing } from './unit-type.model';

export interface Season {
  id: string;
  name: string;
  startDate: Date;
  endDate: Date;
  color: string;
  minStay?: number;
  unitPrices: UnitSeasonPrice[];
}

export interface UnitSeasonPrice {
  unitTypeId: string;
  pricePerNight: number;
  /**
   * Wycena za mniej osób w tym sezonie: { mode, tiers }. mode 'amount' =
   * konkretne kwoty/noc (PLN), 'percent' = rabat % od pricePerNight.
   * undefined = wszyscy płacą cenę za komplet.
   */
  occupancyPricing?: OccupancyPricing;
}

export interface SeasonPreset {
  id: string;
  name: string;
  getDateRange: (year: number) => { startDate: Date; endDate: Date };
}

export const SEASON_PRESETS: SeasonPreset[] = [
  {
    id: 'easter',
    name: 'Wielkanoc',
    getDateRange: (year: number) => {
      const easter = calculateEaster(year);
      const start = new Date(easter);
      start.setDate(start.getDate() - 2);
      const end = new Date(easter);
      end.setDate(end.getDate() + 1);
      return { startDate: start, endDate: end };
    }
  },
  {
    id: 'may_weekend',
    name: 'Majówka',
    getDateRange: (year: number) => ({
      startDate: new Date(year, 4, 1),
      endDate: new Date(year, 4, 3)
    })
  },
  {
    id: 'corpus_christi',
    name: 'Boże Ciało',
    getDateRange: (year: number) => {
      const easter = calculateEaster(year);
      const corpusChristi = new Date(easter);
      corpusChristi.setDate(corpusChristi.getDate() + 60);
      // Long weekend: Thursday (Boże Ciało) + Friday bridge day + weekend
      const start = new Date(corpusChristi);
      const end = new Date(corpusChristi);
      end.setDate(end.getDate() + 3); // Thu–Sun
      return { startDate: start, endDate: end };
    }
  },
  {
    id: 'summer',
    name: 'Wakacje letnie',
    getDateRange: (year: number) => ({
      startDate: new Date(year, 6, 1),
      endDate: new Date(year, 7, 31)
    })
  },
  {
    id: 'christmas',
    name: 'Święta Bożego Narodzenia',
    getDateRange: (year: number) => ({
      startDate: new Date(year, 11, 23),
      endDate: new Date(year, 11, 26)
    })
  },
  {
    id: 'new_year',
    name: 'Sylwester',
    getDateRange: (year: number) => ({
      startDate: new Date(year, 11, 30),
      endDate: new Date(year + 1, 0, 2)
    })
  },
  {
    id: 'winter_break',
    name: 'Ferie zimowe',
    getDateRange: (year: number) => ({
      startDate: new Date(year, 0, 15),
      endDate: new Date(year, 1, 28)
    })
  }
];

export const SEASON_COLORS = [
  '#EF4444', // red
  '#F97316', // orange
  '#EAB308', // yellow
  '#22C55E', // green
  '#06B6D4', // cyan
  '#3B82F6', // blue
  '#8B5CF6', // violet
  '#EC4899', // pink
];

export function calculateEaster(year: number): Date {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}
